/*
 * THG Ingenuity Data Explorer - React Entry Point
 * This file loads the React application for the Office Add-in
 */

// Import React app
import('./index.tsx')
  .catch((error) => {
    console.error('Failed to load React app:', error);
  });